module.exports = __webpack_public_path__ + "static/media/share-btn.68ca1cef.png";